import { useState } from "react";

export const useToggle = (initial = false) => {
  const [value, setValue] = useState<boolean>(initial);

  const handleToggle = () => setValue((prev) => !prev);

  return { value, handleToggle };
};
